import React from 'react'
import { Modal } from '../../../common/Modal'
import { ModalHeader } from '../../../common/Modal/ModalHeader'
import { ModalBody } from '../../../common/Modal/ModalBody'
import { ModalFooter } from '../../../common/Modal/ModalFooter'
import { useAppTranslation } from '../../../../hooks/useAppTranslation'
import { Button } from '../../../common/Button'
import { InactiveSociety } from '../../FindSociety/InactiveSociety'
import { RequestJoinSocietyForm } from '../../FindSociety/RequestiJoinSocietyForm'
import { ISocietiesModel } from '../../../../interfaces/models/societies.interfaces'

interface AlreadyExistingSocietyModalProps {
  show: boolean
  close: () => void
  society: ISocietiesModel | undefined | null
}

export const AlreadyExistingSocietyModal = ({
  show,
  close,
  society,
}: AlreadyExistingSocietyModalProps): React.ReactNode => {
  const { translate } = useAppTranslation()

  const showInactiveForm = society?.status === 'inactive'

  return (
    <Modal show={show} size="sm">
      {{
        header: (
          <ModalHeader onClose={close}>
            {translate('createSocietyForm.headers.societyAlreadyExists')}
          </ModalHeader>
        ),
        body: (
          <ModalBody>
            {showInactiveForm ? (
              <>{society && <InactiveSociety society={society} />}</>
            ) : (
              <>
                {society && (
                  <RequestJoinSocietyForm society={society} onFinish={close} />
                )}
              </>
            )}
          </ModalBody>
        ),
        footer: (
          <ModalFooter>
            <Button
              className="w-full"
              wrapperClassName="w-full"
              label={translate('common.actions.cancel')}
              onClick={close}
            />
          </ModalFooter>
        ),
      }}
    </Modal>
  )
}
